// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.btn-outline-primary{
	color:#32879c ;
	border-color:#32879c;
}
.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:visited, .btn-outline-primary:active, .btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active{
	background-color:#32879c;
	color:#fff;
}

.bg-white{
	background-color:#fff;
}
.headBG {
box-sizing: border-box;
background: #FFFFFF;
border: 1px solid #358696;
}

.mainDiv{
	margin-top:80px;
}

.widget{
	background: #FFFFFF;
box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);
}
.widgetIcon img{
	width:50px;height:50px;
}
.widgetIcon-32 img{
	width:32px;height:32px;
}
.titlebg {
    font-size: 1.2em;
    color: #000;
    font-weight: 500;
    margin-bottom: 10px;
	text-align:center;
}
.chartbox{
	background: #FFFFFF;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    padding: 10px;
    color: #353535;
    /* font-size: 14px; */
}
	h5, .h5 {
    font-size: 1.1rem !important;
}
p {
    line-height: 1rem !important;
}
small, .small {
    font-size: 80% !important;
}
	
table tr td {
	font-size:0.8em;
}
.accordion-button{
	font-size:0.5em;
}
.accordion-button:not(.collapsed){
	background-color:#e0e0e0;
	color:#222;
}

.filterForm > .form-label{
	font-size:0.825em;
}
.form-label{
	font-size:0.825em;
}


	
/***************************** PageTwo *******************************/
.bt-graph {
    border-right: solid 1px #b5b5b5;
}





/* media queries start here */
@media screen and (max-width: 740px) {
.titlebg {
	font-size: 0.9em;
}
}

@media screen and (max-width: 640px) {
.mainDiv{
	margin-top:120px;
}
}
	
@media screen and (max-width: 480px) {
.topHeader h2{
	font-size: 22px;
    padding-right: 3rem;
}
	.titlebg {
		font-size: 0.9em;
	}
}

@media screen and (max-width: 320px) {
	.topHeader h2{
	font-size: 16px;
		padding-right: 0rem;
	}
}

.btn-primary {
    color: #fff;
    background-color: #358696;
    border-color: #358696;
}


.btn-primary:hover {
    color: #fff;
    background-color: #358696;
    border-color: #358696;
}

.btn-primary:focus {
    color: #fff;
    background-color: #358696;
    border-color: #358696;
}

.btn-primary:active {
    color: #fff;
    background-color: #358696;
    border-color: #358696;
}


.btn-secondary{
	color: #fff;
	background: #7b7878 !important;
	border: silver;
}

.btn-secondary:hover{
 color: #fff;
	background: #7b7878;
	border: silver;
  }
  
  .btn-secondary:focus{
    color: #fff;
	background: #7b7878;
	border: silver;
  
  }
  .ev-auto{
	margin-top: -18px; 
}
.ev-auto button{
	margin-top: 18px;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/Driveanalysis/Filterpage.css"],"names":[],"mappings":";AACA;CACC,cAAc;CACd,oBAAoB;AACrB;AACA;CACC,wBAAwB;CACxB,UAAU;AACX;;AAEA;CACC,qBAAqB;AACtB;AACA;AACA,sBAAsB;AACtB,mBAAmB;AACnB,yBAAyB;AACzB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,mBAAmB;AACpB,4CAA4C;AAC5C;AACA;CACC,UAAU,CAAC,WAAW;AACvB;AACA;CACC,UAAU,CAAC,WAAW;AACvB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;CACtB,iBAAiB;AAClB;AACA;CACC,mBAAmB;IAChB,wCAAwC;IACxC,aAAa;IACb,cAAc;IACd,qBAAqB;AACzB;CACC;IACG,4BAA4B;AAChC;AACA;IACI,4BAA4B;AAChC;AACA;IACI,yBAAyB;AAC7B;;AAEA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,wBAAwB;CACxB,UAAU;AACX;;AAEA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;;;;AAIA,sEAAsE;AACtE;IACI,+BAA+B;AACnC;;;;;;AAMA,6BAA6B;AAC7B;AACA;CACC,gBAAgB;AACjB;AACA;;AAEA;AACA;CACC,gBAAgB;AACjB;AACA;;AAEA;AACA;CACC,eAAe;IACZ,mBAAmB;AACvB;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC;CACA,eAAe;EACd,mBAAmB;CACpB;AACD;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;;AAGA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;;AAGA;CACC,WAAW;CACX,8BAA8B;CAC9B,cAAc;AACf;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB,cAAc;EACb;;EAEA;IACE,WAAW;CACd,mBAAmB;CACnB,cAAc;;EAEb;EACA;CACD,iBAAiB;AAClB;AACA;CACC,gBAAgB;AACjB","sourcesContent":["\r\n.btn-outline-primary{\r\n\tcolor:#32879c ;\r\n\tborder-color:#32879c;\r\n}\r\n.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:visited, .btn-outline-primary:active, .btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active{\r\n\tbackground-color:#32879c;\r\n\tcolor:#fff;\r\n}\r\n\r\n.bg-white{\r\n\tbackground-color:#fff;\r\n}\r\n.headBG {\r\nbox-sizing: border-box;\r\nbackground: #FFFFFF;\r\nborder: 1px solid #358696;\r\n}\r\n\r\n.mainDiv{\r\n\tmargin-top:80px;\r\n}\r\n\r\n.widget{\r\n\tbackground: #FFFFFF;\r\nbox-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);\r\n}\r\n.widgetIcon img{\r\n\twidth:50px;height:50px;\r\n}\r\n.widgetIcon-32 img{\r\n\twidth:32px;height:32px;\r\n}\r\n.titlebg {\r\n    font-size: 1.2em;\r\n    color: #000;\r\n    font-weight: 500;\r\n    margin-bottom: 10px;\r\n\ttext-align:center;\r\n}\r\n.chartbox{\r\n\tbackground: #FFFFFF;\r\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\r\n    padding: 10px;\r\n    color: #353535;\r\n    /* font-size: 14px; */\r\n}\r\n\th5, .h5 {\r\n    font-size: 1.1rem !important;\r\n}\r\np {\r\n    line-height: 1rem !important;\r\n}\r\nsmall, .small {\r\n    font-size: 80% !important;\r\n}\r\n\t\r\ntable tr td {\r\n\tfont-size:0.8em;\r\n}\r\n.accordion-button{\r\n\tfont-size:0.5em;\r\n}\r\n.accordion-button:not(.collapsed){\r\n\tbackground-color:#e0e0e0;\r\n\tcolor:#222;\r\n}\r\n\r\n.filterForm > .form-label{\r\n\tfont-size:0.825em;\r\n}\r\n.form-label{\r\n\tfont-size:0.825em;\r\n}\r\n\r\n\r\n\t\r\n/***************************** PageTwo *******************************/\r\n.bt-graph {\r\n    border-right: solid 1px #b5b5b5;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n/* media queries start here */\r\n@media screen and (max-width: 740px) {\r\n.titlebg {\r\n\tfont-size: 0.9em;\r\n}\r\n}\r\n\r\n@media screen and (max-width: 640px) {\r\n.mainDiv{\r\n\tmargin-top:120px;\r\n}\r\n}\r\n\t\r\n@media screen and (max-width: 480px) {\r\n.topHeader h2{\r\n\tfont-size: 22px;\r\n    padding-right: 3rem;\r\n}\r\n\t.titlebg {\r\n\t\tfont-size: 0.9em;\r\n\t}\r\n}\r\n\r\n@media screen and (max-width: 320px) {\r\n\t.topHeader h2{\r\n\tfont-size: 16px;\r\n\t\tpadding-right: 0rem;\r\n\t}\r\n}\r\n\r\n.btn-primary {\r\n    color: #fff;\r\n    background-color: #358696;\r\n    border-color: #358696;\r\n}\r\n\r\n\r\n.btn-primary:hover {\r\n    color: #fff;\r\n    background-color: #358696;\r\n    border-color: #358696;\r\n}\r\n\r\n.btn-primary:focus {\r\n    color: #fff;\r\n    background-color: #358696;\r\n    border-color: #358696;\r\n}\r\n\r\n.btn-primary:active {\r\n    color: #fff;\r\n    background-color: #358696;\r\n    border-color: #358696;\r\n}\r\n\r\n\r\n.btn-secondary{\r\n\tcolor: #fff;\r\n\tbackground: #7b7878 !important;\r\n\tborder: silver;\r\n}\r\n\r\n.btn-secondary:hover{\r\n color: #fff;\r\n\tbackground: #7b7878;\r\n\tborder: silver;\r\n  }\r\n  \r\n  .btn-secondary:focus{\r\n    color: #fff;\r\n\tbackground: #7b7878;\r\n\tborder: silver;\r\n  \r\n  }\r\n  .ev-auto{\r\n\tmargin-top: -18px; \r\n}\r\n.ev-auto button{\r\n\tmargin-top: 18px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
